import Model from "~/models/_Model";

export default class ComparisonCategory extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "comparisons/categories";
  }

  get sort_key() {
    return "";
    //return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  get public_fields() {
    const calc_map = {
      1: "Percent",
      2: "Total Points",
    };
    return [
      {
        name: "title",
        label: "Title",
        format: (val) => val,
      },
      {
        name: "weight",
        label: "Weight",
        format: (val) => val,
      },
      {
        name: "drop_lowest",
        label: "Drop Lowest X Assignments",
        format: (val) => val,
      },
      {
        name: "calculation_type",
        label: "Calculation Type",
        format: (val) => calc_map[val] || val,
      },
    ];
  }

  getResultCount(resultType = null) {
    if (resultType) {
      return this.results[resultType].length;
    }
    let count = 0;
    Object.values(this.results).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
}
